import { useRef } from 'react';

/**
 * Keeps a ref pointed at the latest value on every render, so async callbacks
 * (deferred blur handlers, timeouts) can read the current value without
 * capturing a stale closure. Same read semantics as `const r = useRef(v);
 * r.current = v;` — just named for intent.
 */
export function useLatestRef<V>(value: V): React.MutableRefObject<V> {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
